"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var react_1 = __importDefault(require("react"));
var AuthButtons_1 = require("../../AuthButtons");
var ChangeLanguage_1 = require("../../ChangeLanguage");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var NotAuthMenu = function (_a) {
    var isNarrowXl = _a.isNarrowXl, languages = _a.languages, textVariant = _a.textVariant, changeLanguageVariant = _a.changeLanguageVariant;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement(react_1.default.Fragment, null, Object.keys(breakpoints).length > 0 &&
        !breakpoints.mobile &&
        !breakpoints.tablet && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AuthButtons_1.AuthButtons, { textVariant: textVariant }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.notAuthLang },
            react_1.default.createElement(ChangeLanguage_1.ChangeLanguage, { isAuth: false, isNarrowXl: isNarrowXl, languages: languages, variant: changeLanguageVariant }))))));
};
exports.default = NotAuthMenu;
